// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-login-dialog .v-stack-dialog__content{color:#000!important;background:#fff!important}.h-login-dialog .v-stack-dialog__body{margin-bottom:20px!important}", ""]);
// Exports
module.exports = exports;
